import {Box, Typography} from '@mui/material';
import {BrowserRouter} from 'react-router-dom';
import styled from 'styled-components';

import AssistantList from '../components/chatbot/AssistantList/AssistantList';
import Header from '../components/header/Header/Header';
import Spinner from '../components/spinner/Spinner';
import PageTitle from '../components/typography/PageTitle';
import {FONT_FAMILIES} from '../const';
import LogoSvg from '../img/company-logo';
import LoginForm from './Login/LoginForm';
import Maintenance from './Maintenance/Maintenance';

const LoginFormContainer = styled.div`
  display: flex;
  height: 100vh;
  width: 100%;
  overflow-y: hidden;
`;

const LogoContainerNewChatbotConversation = styled.div`
  img {
    max-height: 130px;
    width: 100%;
  }
`;

const VisualdentityTestPage = () => {
  const azureB2CUrl = `https://drivnb2c.blob.core.windows.net/b2c-login/${import.meta.env.VITE_COMPANY_NAME}/template/unified.html`;

  return (
    <BrowserRouter>
      <Box py={3} px={1}>
        <Box pb={3}>
          <Typography fontSize={30} mb={2}>
            Typography
          </Typography>
          <Typography>This is default text font</Typography>
          <Typography fontWeight="bold">This is bold text font</Typography>
          <br />
          <Typography fontFamily={FONT_FAMILIES.TITLE}>This is normal title font</Typography>
          <Typography fontWeight="bold" fontFamily={FONT_FAMILIES.TITLE}>
            This is bold title font
          </Typography>
          <PageTitle>This is page title</PageTitle>
        </Box>

        <Box pb={3}>
          <Typography fontSize={30} mb={2}>
            Header component (logo.svg)
          </Typography>
          <Header />
        </Box>

        <Box pb={3}>
          <Typography fontSize={30} mb={2}>
            Spinner
          </Typography>
          <Spinner isLoading size={64} />
        </Box>

        <Box pb={3}>
          <Typography fontSize={30} mb={2}>
            Homepage (colors + logo.svg)
          </Typography>
          <LoginFormContainer>
            <LoginForm />
          </LoginFormContainer>
        </Box>

        <Box pb={3}>
          <Typography fontSize={30} mb={2}>
            Page de maintenance (symbol dark)
          </Typography>
          <Maintenance />
        </Box>

        <Box pb={3}>
          <Typography fontSize={30} mb={2}>
            Nouvelle conversastion chatbot (symbol.svg)
          </Typography>
          <>
            <LogoContainerNewChatbotConversation>
              <LogoSvg isSymbol />
            </LogoContainerNewChatbotConversation>
            <Typography px={1} textAlign="center" fontFamily={FONT_FAMILIES.TITLE} fontSize={22} color="primary" mt={0} mb={0}>
              Avec qui souhaitez-vous discuter ?
            </Typography>
            <AssistantList />
          </>
        </Box>

        <Box pb={3}>
          <Typography fontSize={30} mb={2}>
            Page azure B2C login (unified.html)
          </Typography>
          <a target="_blank" href={azureB2CUrl} rel="noreferrer">
            lien vers la page azure B2C
          </a>
        </Box>
      </Box>
    </BrowserRouter>
  );
};

export default VisualdentityTestPage;
